import React from 'react';
import { ABOUT, COLORS } from '../../data/siteData';
import { Library, BookOpen, Building2, Clock } from 'lucide-react';

const iconMap = {
  library: Library,
  book: BookOpen,
  building: Building2,
  clock: Clock,
};

const AboutSection = () => {
  return (
    <section id="about" className="py-20" style={{ backgroundColor: COLORS.background }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" style={{ color: COLORS.dark }}>
            {ABOUT.title}
          </h2>
          <p className="text-lg" style={{ color: COLORS.gray }}>
            {ABOUT.description}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ABOUT.features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon] || Library;
            return (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
              >
                <div 
                  className="w-12 h-12 rounded-lg flex items-center justify-center mb-4"
                  style={{ backgroundColor: `${COLORS.green}15` }}
                >
                  <IconComponent 
                    className="w-6 h-6" 
                    style={{ color: COLORS.green }}
                  />
                </div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: COLORS.dark }}>
                  {feature.title}
                </h3>
                <p className="text-sm" style={{ color: COLORS.gray }}>
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
